import { InfinityListManagerWithoutCheckboxAndCustomParams } from '../../../components/Hooks/infinity-list/infinityList.types';
import useInfiniteDataQuery from '../useInfiniteDataQuery';

interface DefaultPageData {
  [key: string]: any;
}

export class UseInfiniteDataQueryTransformers {
  static toInfinityListManagerWithoutCheckboxAndCustomParams<T extends DefaultPageData>({
    query,
    mutateMethods,
  }: ReturnType<
    typeof useInfiniteDataQuery<T>
  >): InfinityListManagerWithoutCheckboxAndCustomParams<T> {
    return {
      reload: query.refetch,
      removeItem: mutateMethods.removeByIndex,
      updateItem: mutateMethods.mutateByIndex,
      replaceAllItems: mutateMethods.replaceAllItems,
      reset: () => {
        query.refetch();
      },
      loadMoreRows: async () => {
        await query.fetchNextPage();
      },
      state: {
        isLoadingPage: query.isLoading,
        hasMore: !!query.hasNextPage,
        isLoadingMore: query.isFetchingNextPage,
        totalItems: query.countData?.total || 0,
        items: query.isError ? [] : query.pagesData || [],
        page: query.pageParams ? query.pageParams.length : 0,
        selecteds: [],
      },
    };
  }
}
